import React from 'react';
import { ExposedData, PlayFunction } from 'use-sound/dist/types';

import { useSound } from './useSound';

import beepsPath from '../../assets/beeps.wav';
import ringtonePath from '../../assets/ringtone.mp3';
import hangPath from '../../assets/hang.mp3';
import { useStrictContext } from '../../lib/useStrictContext';

type SoundsContext = Record<'beeps' | 'ringtone' | 'hang', {
    play: PlayFunction;
    controller: ExposedData;
}>

const Context = React.createContext<SoundsContext | null>(null);

interface SoundsProviderProps {
    children: React.ReactElement;
}

export const SoundsProvider: React.FC<SoundsProviderProps> = ({ children }) => {
    const beeps = useSound(beepsPath, {
        loop: true,
    });
    const ringtone = useSound(ringtonePath, {
        loop: true,
    });
    const hang = useSound(hangPath, {
        loop: true,
    });

    const value = React.useMemo<SoundsContext>(() => ({
        beeps: {
            play: beeps[0],
            controller: beeps[1],
        },
        hang: {
            play: hang[0],
            controller: hang[1],
        },
        ringtone: {
            play: ringtone[0],
            controller: ringtone[1],
        },
    }), [beeps, ringtone, hang]);

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useSounds = () => useStrictContext(Context);
